import {
  CalendarOutlined,
  ContainerOutlined,
  DashboardOutlined,
  IdcardOutlined,
  ShopOutlined,
  TeamOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { Col, Menu, Row } from "antd";
import Sider from "antd/lib/layout/Sider";
import SubMenu from "antd/lib/menu/SubMenu";
import BindeleddetInternalLogo from "assets/images/bindeleddetLogo/BL_logo_internal_white.png";
import { Link, NavLink } from "react-router-dom";

export const NAVMENU_WIDTH = 270;

export const MenuContent = ({ children, onSelect }: { children?: React.ReactNode; onSelect?: () => void }) => {
  return (
    <Row gutter={[0, 56]} justify="center">
      <Col>
        <Link to="/admin/" style={{ margin: "auto" }}>
          <img
            src={BindeleddetInternalLogo}
            alt="BL logo white"
            style={{
              position: "relative",
              height: "40px",
              top: "13px",
              right: "31px",
              display: "block",
            }}
          />
        </Link>
      </Col>
      <Col style={{ width: "100%" }}>
        <Menu
          mode="inline"
          theme="dark"
          defaultSelectedKeys={["1"]}
          style={{ height: "100%", border: "none", backgroundColor: "var(--primary-color)" }}
        >
          <Menu.Item key="1" icon={<DashboardOutlined />} onClick={onSelect}>
            <NavLink exact to="/admin/">
              Dashboard
            </NavLink>
          </Menu.Item>
          <Menu.Item key="2" icon={<CalendarOutlined />} onClick={onSelect}>
            <NavLink exact to="/admin/events/">
              Arrangementer
            </NavLink>
          </Menu.Item>
          <Menu.Item key="3" icon={<ShopOutlined />} onClick={onSelect}>
            <NavLink to="/admin/companies/">Bedrifter</NavLink>
          </Menu.Item>
          <Menu.Item key="4" icon={<TeamOutlined />} onClick={onSelect}>
            <NavLink to="/admin/students/">Studenter</NavLink>
          </Menu.Item>
          <Menu.Item key="5" icon={<IdcardOutlined />} onClick={onSelect}>
            <NavLink to="/admin/members/">Medlemmer</NavLink>
          </Menu.Item>
          <SubMenu key="sub1" title="Ressurser" icon={<ContainerOutlined />} style={{ padding: 0 }}>
            <Menu.Item key="6" onClick={onSelect}>
              <NavLink to="/admin/resources/casebank/">Casebank</NavLink>
            </Menu.Item>
            <Menu.Item key="7" onClick={onSelect}>
              <NavLink to="/admin/resources/articles/">Artikler</NavLink>
            </Menu.Item>
            <Menu.Item key="8" onClick={onSelect}>
              <NavLink to="/admin/resources/publications/">Publikasjoner</NavLink>
            </Menu.Item>
          </SubMenu>
          <SubMenu key="sub2" title="Verktøy" icon={<ToolOutlined />} style={{ padding: 0 }}>
            <Menu.Item key="9" onClick={onSelect}>
              <NavLink to="/admin/tools/send-email/">Send e-post</NavLink>
            </Menu.Item>
            <Menu.Item key="10" onClick={onSelect}>
              <NavLink to="/admin/tools/analyse/">Analyse</NavLink>
            </Menu.Item>
            <Menu.Item key="11" onClick={onSelect}>
              <NavLink to="/admin/tools/booking-seasons/">Bookingsesonger</NavLink>
            </Menu.Item>
            <Menu.Item key="12" onClick={onSelect}>
              <NavLink to="/admin/tools/take-attendance-for-event/">Innslippsappen</NavLink>
            </Menu.Item>
          </SubMenu>
          <div style={{ width: "100%", textAlign: "center" }}>{children}</div>
        </Menu>
      </Col>
    </Row>
  );
};
export const NavMenu = () => {
  return (
    <Sider
      width={NAVMENU_WIDTH}
      breakpoint="md"
      collapsedWidth="0"
      trigger={null}
      style={{
        overflow: "auto",
        minHeight: "100vh",
        position: "fixed",
        backgroundColor: "var(--primary-color)",
        boxShadow: "1px 0px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <MenuContent />
    </Sider>
  );
};
